import React, { useContext } from 'react'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import QuestionHeading from '@f/applications/QuizApp/partials/QuestionHeading'
import { QUIZ_STEP_TYPES } from '@f/applications/QuizApp/partials/quizConstants'
import { QuestionRadioButton } from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioButton'
import { BarTile } from '@f/elements/BarTile/BarTile'

const QuestionRadioBarTiles = ({ step }) => {
  const context = useContext(QuizContext)

  const questionOptions = step.options.map(option => ({
    ...option,
    ItemTemplate: radio => <BarTile label={radio.label} />
  }))

  const handleChange = value => {
    const defaultIndicates = ['funnel-step-change']
    if (step.type === QUIZ_STEP_TYPES.property) {
      defaultIndicates.push('user-input')
    }

    const indicates = step.indicates || defaultIndicates

    const trackingValues = Array.isArray(value)
      ? [
          ...value.map(v => ({
            type: v.name,
            value: v.value
          }))
        ]
      : [
          {
            type: step._wtName,
            value: value
          }
        ]

    window._wt({
      category: 'form',
      action: 'submit',
      location: `question-${step._wtName}`,
      indicates,
      values: trackingValues,
      ...context.tracking.flow
    })

    context.actions.updateValues({
      stepID: step.id,
      valuesToSave: [
        {
          name: step.values[0].name,
          value: value
        }
      ]
    })

    context.actions.move({ to: 'next', triggerSubmit: false })
  }

  return (
    <>
      <QuestionHeading heading={step.heading} subheading={step.subheading} />
      <div
        className={`[ f-m-h-auto ] QuestionRadio-wrap ${
          step.options.length > 4
            ? 'has-more-than-four-elements'
            : step.options.length === 4
            ? 'has-four-elements'
            : ''
        }`}>
        <div className='[ f-d-flc ] QuestionRadio-options'>
          <div className='QuestionRadio-bar-tiles'>
            {questionOptions.map(option => (
              <QuestionRadioButton
                key={`${option.value}-${option.label}`}
                wtData={{
                  location: `question-${step._wtName}`,
                  flow_information: context.tracking.flow.flow_information
                }}
                onClick={() => handleChange(option.value)}>
                <BarTile label={option.label} />
              </QuestionRadioButton>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default QuestionRadioBarTiles
